import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaintenanceRoutingModule } from './maintenance-routing.module';
import { MaintenanceComponent } from './components/maintenance.component';


@NgModule({
  imports: [
    CommonModule,
    MaintenanceRoutingModule,
    TranslateModule.forChild()
  ],
  declarations: [MaintenanceComponent]
})
export class MaintenanceModule { }
